<template>
  <section id="team-intro">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <p class="intro-text text-center">
            身為團隊成員的四人是這個故事村中的說書人角色，<br>透過無限的想像力與創造力，勾勒出屬於八斗里這片土地的趣味故事，<br>並運用我們的角度表達給身為聽書人的八斗里的居民以及遊客們，帶給眾人愉快與沈浸的體驗感受。
          </p>
        </div>
      </div>
    </div>
  </section>
  <section id="member-intro">
    <div class="container">
      <div class="row team-img-row ">
        <div class="col-md-6  aos-init aos-animate" v-for="(ppl, index) in pplImgList" :key="index"  data-aos="fade-in">
          <img class="ppl-img" :src="getImageSrc(ppl)" alt="">
          <h2 class="name-text">{{ nameList[index] }}</h2>
          <p class="introduction-text">{{ introduction[index] }}</p>
        </div>
      </div>
    </div>
  </section>
  <footer class="mt-5">
    <div class="container">
      <div class="row">
        <p class="text-center">©2024 八斗故事村</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      pplImgList: ["1.jpg", "2.jpg", "3.jpg", "4.jpg"],
      nameList: ["許馨方", "游千慧", "劉羿伶", "許慈茵"],
      introduction: ["海大文創系的在讀學生，是個微社恐星人。而身為古靈精怪的雙子座，除了喜歡音樂和小說，對歷史還有漂亮的美景也抱有許多熱忱，期望透過這個網站帶大家了解歷史與故事的魅力，也讓大家更了解八斗里這片土地。",
        "海大文創系大三學生，熱愛歷史及一切可愛的東西，想可以在大四畢業以前交出自己滿意的成果給自己看，目前正在學校的社會責任實踐組工讀中，希望也可以將工讀的經驗運用到這裡。",
        "我是劉羿伶，就讀於海洋大學文創設計系。希望能運用所學，與團隊成員們做出一個創新且完善的計劃，並透過這次機會，讓更多人認識八斗里的美！",
        "海大文創系大三學生，因為喜歡歷史和畫畫而選了設計系，希望能在畢業之前為基隆和八斗里做點什麼，所以參加了這個計畫。"
      ]
    }
  },
  methods: {
    getImageSrc(imageName) {
      return require(`@/assets/team-img/${imageName}`);
    }
  }
}
</script>
<style lang="scss" scoped>
.ppl-img {
  width: 100%;
  height: auto;
  object-fit: cover;
  padding: 1rem;
  border-radius: 30px;
}
.team-img-row {
  margin-top: 2rem;
  padding: 0 2rem;
}

.name-text{
  padding-left: 1rem;
}

.introduction-text {
  padding: 1rem;
}
.intro-text{
  font-size: 18px;
  margin-top: 6rem;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 3rem;
}
footer {
  padding: 0.5rem;
  background: #7bcadd;
  color: #fff;
  font-family: "Noto Sans TC", sans-serif;
  font-weight: 600;
}

</style>
